/**
 * Infers the nesting depth from a field path.
 *
 * @param fieldPath - The field path (e.g., "children.0", "children.0.children.1")
 * @returns The depth (1 for root/first level children, 2 for nested fieldset children, etc.)
 *
 * @example
 * getDepthFromFieldPath(undefined) // 1 (root fieldset, no type selector shown)
 * getDepthFromFieldPath('children.0') // 1
 * getDepthFromFieldPath('children.0.children.1') // 2
 */
export function getDepthFromFieldPath(fieldPath?: string): number {
  if (!fieldPath) return 1;

  // Count occurrences of "children" in the path
  const matches = fieldPath.match(/children/g);
  return matches?.length ?? 1;
}
